import { defineMessages } from 'react-intl';

export const redirects = defineMessages({
  businessPageRedirect: {
    id: 'src.constants.redirects.businessPageRedirect',
    defaultMessage: '/zakelijk',
  },
  redeemClientServiceRedirect: {
    id: 'src.constants.redirects.redeemClientServiceRedirect',
    defaultMessage: 'https://www.cadeaubon.nl/helpdesk',
  },
  redeemLogoRedirect: {
    id: 'src.constants.redirects.redeemLogoRedirect',
    defaultMessage: 'https://www.cadeaubon.nl/',
  },
  redeemTermsAndConditionsRedirect: {
    id: 'src.constants.redirects.redeemTermsAndConditionsRedirect',
    defaultMessage: 'https://www.cadeaubon.nl/algemene-voorwaarden',
  },
  redeemPrivacyRedirect: {
    id: 'src.constants.redirects.redeemPrivacyRedirect',
    defaultMessage: 'https://www.cadeaubon.nl/privacy',
  },
  helpdeskRedirect: {
    id: 'src.constants.redirects.helpdeskRedirect',
    defaultMessage: '/helpdesk/',
  },
  popRedirect: {
    id: 'src.constants.redirects.popRedirect',
    defaultMessage: '{page, plural, =1 {/cadeaubonnen/} other {/cadeaubonnen/{page}/}}',
  },
  copRedirect: {
    id: 'src.constants.redirects.copRedirect',
    defaultMessage: '{page, plural, =1 {/categorie/{url}/} other {/categorie/{url}/{page}/}}',
  },
  homePageRedirect: {
    id: 'src.constants.redirects.homePageRedirect',
    defaultMessage: '/',
  },
  basketPageRedirect: {
    id: 'src.constants.redirects.basketPageRedirect',
    defaultMessage: '/winkelmandje/',
  },
  blogPopRedirect: {
    id: 'src.constants.redirects.blogPopRedirect',
    defaultMessage: '/blog/',
  },
  checkoutPageRedirect: {
    id: 'src.constants.redirects.checkoutPageRedirect',
    defaultMessage: '/bestellen/',
  },
  redeemnCheckoutPageRedirect: {
    id: 'src.constants.redirects.redeemnCheckoutPageRedirect',
    defaultMessage: '/saldocheck/checkout/',
  },
  redeemPageRedirect: {
    id: 'src.constants.redirects.redeemPageRedirect',
    defaultMessage: '/saldocheck/',
  },
  redeemShopPageRedirect: {
    id: 'src.constants.redirects.redeemShopPageRedirect',
    defaultMessage: '{page, plural, =1 {/saldocheck/inwisselen/} other {/saldocheck/inwisselen/{page}/}}',
  },
  redeemB2BShopPageRedirect: {
    id: 'src.constants.redirects.redeemB2BShopPageRedirect',
    defaultMessage: '{page, plural, =1 {/saldocheck/inwisselen/{pageId}/} other {/saldocheck/inwisselen/{pageId}/{page}/}}',
  },
  privacyPageRedirect: {
    id: 'src.constants.redirects.privacyPageRedirect',
    defaultMessage: '/privacy/',
  },
  termsAndConditionsRedirect: {
    id: 'src.constants.redirects.termsAndConditionsRedirect',
    defaultMessage: '/algemene-voorwaarden/',
  },
  doublerHomePageRedirect: {
    id: 'src.constants.redirects.doublerHomePageRedirect',
    defaultMessage: '/verdubbelaar/',
  },
  notFoundPageRedirect: {
    id: 'src.constants.redirects.notFoundPageRedirect',
    defaultMessage: '/404/',
  },
  accountIdentifyPageRedirect: {
    id: 'src.constants.redirects.accountIdentifyPageRedirect',
    defaultMessage: '/account/',
  },
  accountRegisterPageRedirect: {
    id: 'src.constants.redirects.accountRegisterPageRedirect',
    defaultMessage: '/account/registreren/',
  },
  accountRegisterSuccessPageRedirect: {
    id: 'src.constants.redirects.accountRegisterSuccessPageRedirect',
    defaultMessage: '/account/registreren/success/',
  },
  loginPageRedirect: {
    id: 'src.constants.redirects.loginPageRedirect',
    defaultMessage: '/account/login/',
  },
  forgotPasswordPageRedirect: {
    id: 'src.constants.redirects.forgotPasswordPageRedirect',
    defaultMessage: '/account/wachtwoord-vergeten/',
  },
  forgotPasswordConfirmPageRedirect: {
    id: 'src.constants.redirects.forgotPasswordConfirmPageRedirect',
    defaultMessage: '/account/wachtwoord-vergeten/success/',
  },
  newPasswordPageRedirect: {
    id: 'src.constants.redirects.newPasswordPageRedirect',
    defaultMessage: '/account/nieuw-wachtwoord/',
  },
  newPasswordConfirmationPageRedirect: {
    id: 'src.constants.redirects.newPasswordConfirmationPageRedirect',
    defaultMessage: '/account/nieuw-wachtwoord/succes/',
  },
  accountDataPageRedirect: {
    id: 'src.constants.redirects.accountDataPageRedirect',
    defaultMessage: '/account/gegevens/',
  },
  accountOverviewPageRedirect: {
    id: 'src.constants.redirects.accountOverviewPageRedirect',
    defaultMessage: '/account/overzicht/',
  },
  accountOrdersPageRedirect: {
    id: 'src.constants.redirects.accountOrdersPageRedirect',
    defaultMessage: '/account/bestellingen/',
  },
  locationDetailsPageRedirect: {
    id: 'src.constants.redirects.locationDetailsPageRedirect',
    defaultMessage: '/cadeaubonnen/:product/locaties/:location/',
  },
  reorderPageRedirect: {
    id: 'src.constants.redirects.reorderPageRedirect',
    defaultMessage: '/nabestellen/',
  },
  choiceGiftcardRedirect: {
    id: 'src.constants.redirects.choiceGiftcardRedirect',
    defaultMessage: '/cadeaubonnen/cadeaubonnl-keuze-cadeaukaart/',
  },
  choiseExplanationPdfRedirect: {
    id: 'src.constants.redirects.choiseExplanationPdfRedirect',
    defaultMessage: 'https://www.cadeaubon.nl/sites/live/files/CB-NL-KCK-Inwisselproces.pdf',
  },
  promoPopUpRedirect: {
    id: 'src.constants.redirects.promoPopUpRedirect',
    defaultMessage: 'https://www.onderzoekdoen.nl/enq/?f=rm6o4xus1f',
  },
});
